export { default as Img200 } from './processed/200/The-Real-War-of-Thrones-1.jpg';
export { default as Img400 } from './processed/400/The-Real-War-of-Thrones-1.jpg';
export { default as Imgthumb } from './processed/thumb/The-Real-War-of-Thrones-1.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/The-Real-War-of-Thrones-1.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/The-Real-War-of-Thrones-1.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      187,
      145,
      92
    ],
    "_population": 2842,
    "_hsl": [
      0.09298245614035089,
      0.41125541125541126,
      0.5470588235294117
    ]
  },
  "LightVibrant": {
    "_rgb": [
      221,
      196,
      144
    ],
    "_population": 7,
    "_hsl": [
      0.11255411255411257,
      0.5310344827586208,
      0.7156862745098039
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      78,
      47,
      11
    ],
    "_population": 721,
    "_hsl": [
      0.08955223880597014,
      0.7528089887640449,
      0.17450980392156865
    ]
  },
  "Muted": {
    "_rgb": [
      140,
      115,
      76
    ],
    "_population": 3045,
    "_hsl": [
      0.10156249999999999,
      0.29629629629629634,
      0.42352941176470593
    ]
  },
  "LightMuted": {
    "_rgb": [
      217,
      200,
      168
    ],
    "_population": 308,
    "_hsl": [
      0.108843537414966,
      0.392,
      0.7549019607843137
    ]
  },
  "DarkMuted": {
    "_rgb": [
      80,
      69,
      44
    ],
    "_population": 1121,
    "_hsl": [
      0.11574074074074071,
      0.2903225806451613,
      0.24313725490196078
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/The-Real-War-of-Thrones-1.js